import { CircularProgress } from '@mui/material'
import Script from 'next/script'
import { Typography } from '@evocolabs/orkaui'
import { useEffect } from 'react'

const OrkaTwoMV = () => {
  useEffect(() => {
    const modelViewer = document.getElementById('orka-two-3d-model')
    modelViewer.addEventListener('load', async () => {
      modelViewer.animationName = 'Animation'
      await modelViewer.updateComplete
      modelViewer.play({ repetitions: 1 })
    })
  }, [])
  return (
    <>
      <Script type="module" src="/3d/model-viewer.js"></Script>
      <model-viewer
        style={{ width: '100%', height: '100%' }}
        alt="Neil Armstrong's Spacesuit from the Smithsonian Digitization Programs Office and National Air and Space Museum"
        src="https://legacy-cdn.hiorka.com/imgs/ca-frontend/orka2model_draco.glb"
        id="orka-two-3d-model"
        loading="eager"
        shadow-intensity="0"
        camera-controls
        touch-action="none"
      >
        <div
          slot="poster"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            gap: '8px'
          }}
        >
          <CircularProgress />
          <Typography variant="body4">Orka Model Loading</Typography>
        </div>
      </model-viewer>
    </>
  )
}

export default OrkaTwoMV
